import Gleap from 'gleap';
import { GLEAP_SDK_KEY, NODE_ENV, API_ADDRESS } from '@/constants/env';
import { getUIRole } from '@/pages/UserPreferences/utils';

export enum GleapUserType {
  USER = 'User',
  LEAD = 'Lead',
}

export class GleapManager {
  private static isInitialized = false;

  public static init() {
    if (NODE_ENV === 'production' && !API_ADDRESS.includes('localhost') && GLEAP_SDK_KEY) {
      if (!this.isInitialized) {
        Gleap.initialize(GLEAP_SDK_KEY);
        this.isInitialized = true;
      }
    }
  }

  public static identifyUser(user: {
    userId: string;
    displayName: string;
    email: string;
    org: string;
    permission?: string;
    phoneNumber?: string;
    title?: string;
    role?: string;
  }) {
    if (!this.isInitialized) return;

    const mergedPermission = getUIRole(user.role || '', user.permission || '');

    Gleap.identify(user.userId, {
      name: user.displayName,
      email: user.email,
      companyName: user.org,
      ...(user.phoneNumber && { phoneNumber: user.phoneNumber }),
      ...(user.title && { title: user.title }),
      customData: { permission: mergedPermission },
    });

    Gleap.setCustomData('userType', GleapUserType.USER);
  }

  public static identifyLead() {
    if (!this.isInitialized) return;

    Gleap.clearIdentity();
    Gleap.setCustomData('userType', GleapUserType.LEAD);
  }

  public static clearIdentity() {
    if (!this.isInitialized) return;

    Gleap.clearIdentity();
  }

  public static pushTrackEvent(eventName: string, payload?: any) {
    if (GLEAP_SDK_KEY) {
      Gleap.trackEvent(eventName, payload);
    }
  }

  public static pushCustomData(key: string, value: any) {
    if (GLEAP_SDK_KEY) {
      Gleap.setCustomData(key, value);
    }
  }

  public static setUserStats(stats: {
    products_active: number;
    products_deleted: number;
    collections_active: number;
    collections_deleted: number;
  }) {
    if (!this.isInitialized) return;

    Gleap.setCustomData('products_active', String(stats.products_active));
    Gleap.setCustomData('products_deleted', String(stats.products_deleted));
    Gleap.setCustomData('collections_active', String(stats.collections_active));
    Gleap.setCustomData('collections_deleted', String(stats.collections_deleted));
  }
}
